import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Primary, SelectField } from "@cinch-labs/design-system";
import { formatNumber } from "@cinch-labs/shared-util";
import { EventNames, TrackingEventTypes, addDataDogUserAction, useAnalytics } from "@cinch-nx/shared-analytics";
import { useState } from "react";
import styles from "./filters.module.css";
var modelToOptions = function(models) {
    return models.map(function(model) {
        return {
            label: "".concat(model.name, " (").concat(model.stock, ")"),
            value: model.name,
            count: "".concat(model.stock)
        };
    });
};
var getSearchButtonText = function(quantity) {
    return quantity === 1 ? "Search 1 car" : "Search ".concat(quantity, " cars");
};
export var Filters = function(param) {
    var totalStock = param.totalStock, makes = param.makes;
    var trackEvent = useAnalytics().trackEvent;
    var ref = useState(""), selectedMake = ref[0], setSelectedMake = ref[1];
    var ref1 = useState(""), selectedModel = ref1[0], setSelectedModel = ref1[1];
    var ref2 = useState("Search all ".concat(formatNumber(totalStock), " cars")), searchButtonText = ref2[0], setSearchButtonText = ref2[1];
    var ref3 = useState([]), modelOptions = ref3[0], setModelOptions = ref3[1];
    var handleOnChangeTracking = function(id, value) {
        trackEvent({
            eventName: id === "make" ? "Homepage make dropdown" : "Homepage model dropdown",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "filter",
                    action: "select",
                    label: id,
                    value: value === null || value === void 0 ? void 0 : value.toLowerCase()
                }
            }
        });
        addDataDogUserAction("Select ".concat(value, " from ").concat(id, "s list"), {
            vehicle: _define_property({}, id, value)
        });
    };
    var handleMakeFilterChange = function(e) {
        var value = e.target.value === "Any" ? undefined : e.target.value;
        handleOnChangeTracking("make", value);
        if (value) {
            setSelectedMake(value);
            var make = makes.find(function(make) {
                return make.name === value;
            });
            setSearchButtonText(getSearchButtonText(make.stock));
            setModelOptions(modelToOptions(make.models));
        } else {
            setSelectedMake("");
            setSelectedModel("");
            setSearchButtonText("Search all ".concat(totalStock, " cars"));
        }
    };
    var handleModelFilterChange = function(e) {
        var value = e.target.value === "Any" ? undefined : e.target.value;
        handleOnChangeTracking("model", value);
        if (value) {
            var ref;
            setSelectedModel(value);
            var model = (ref = makes.find(function(make) {
                return make.name === selectedMake;
            })) === null || ref === void 0 ? void 0 : ref.models.find(function(model) {
                return model.name === value;
            });
            setSearchButtonText(getSearchButtonText(model.stock));
        } else {
            var make = makes.find(function(make) {
                return make.name === selectedMake;
            });
            setSearchButtonText(getSearchButtonText(make.stock));
            setSelectedModel("");
        }
    };
    var makeOptions = makes.map(function(make) {
        return {
            label: "".concat(make.name, " (").concat(make.stock, ")"),
            value: make.name,
            count: "".concat(make.stock)
        };
    });
    var handleOnSubmitTracking = function() {
        var trackEventName = "Homepage filter search all cars";
        var actionName = "";
        if (selectedMake) {
            trackEventName = "Homepage filter search now";
            actionName = selectedModel ? "".concat(selectedMake, ",").concat(selectedModel) : "".concat(selectedMake);
        }
        trackEvent({
            eventName: trackEventName,
            type: TrackingEventTypes.ADOBE,
            data: {
                action: actionName,
                event: {
                    name: "submit",
                    category: "form",
                    action: "submit",
                    label: "search cars",
                    value: trackEventName
                }
            }
        });
    };
    var handleVehiclesFilterSubmit = function(e) {
        handleOnSubmitTracking();
        e.preventDefault();
        var rawSearchParams = {};
        if (selectedMake) {
            rawSearchParams.make = selectedMake;
        }
        if (selectedModel) {
            rawSearchParams.selectedModel = selectedModel;
        }
        var searchParams = new URLSearchParams(rawSearchParams);
        window.location.assign("/find-vehicle?".concat(searchParams.toString()));
    };
    var handleSearchButtonClickTracking = function() {
        trackEvent({
            eventName: "Search all cars",
            type: TrackingEventTypes.ADOBE,
            data: {
                action: searchButtonText,
                event: {
                    name: EventNames.click,
                    category: "button",
                    label: "search cars"
                }
            }
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: styles["container"],
        children: /*#__PURE__*/ _jsxs("form", {
            className: styles["form"],
            onSubmit: handleVehiclesFilterSubmit,
            children: [
                /*#__PURE__*/ _jsx(SelectField, {
                    label: "Select make",
                    labelHidden: true,
                    id: "make",
                    "data-testid": "make-select",
                    options: makeOptions,
                    placeholder: "Select make",
                    placeholderValue: "Any",
                    value: selectedMake,
                    onChange: handleMakeFilterChange,
                    classNames: {
                        container: styles["selectContainer"],
                        select: styles["select"],
                        arrow: styles["arrow"]
                    },
                    error: {
                        show: false
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles["selectDivide"]
                }),
                /*#__PURE__*/ _jsx(SelectField, {
                    label: "Select model",
                    labelHidden: true,
                    id: "model",
                    "data-testid": "model-select",
                    options: modelOptions,
                    placeholder: "Select model",
                    placeholderValue: "Any",
                    value: selectedModel,
                    onChange: handleModelFilterChange,
                    disabled: !selectedMake,
                    classNames: {
                        container: styles["selectContainer"],
                        select: styles["select"],
                        arrow: styles["arrow"]
                    },
                    error: {
                        show: false
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles["buttonContainer"],
                    children: /*#__PURE__*/ _jsx(Primary, {
                        type: "submit",
                        classNames: {
                            button: styles["button"]
                        },
                        "data-testid": "searchButton",
                        isFullWidth: true,
                        onClick: handleSearchButtonClickTracking,
                        children: searchButtonText
                    })
                })
            ]
        })
    });
};
